@if (aberto()) {
  <app-modal
    [isOpen]="aberto()"
    size="md"
    icone="mail_account"
    descricao="Aceite para ter acesso à empresa ou recuse o convite."
    [closeOverlayClick]="false"
    [fecharNoEsc]="!recusaPendente()"
    (closeModal)="fechar()"
  >
    <app-modal-header>{{ cartoes().length > 1 ? 'Convites para você' : 'Convite para você' }}</app-modal-header>

    <div modalBody>
      <div class="flex flex-col gap-3">
        @for (cartao of cartoes(); track cartao.convite.id) {
          <article
            class="flex flex-col gap-3 rounded-xl border border-border-primary p-4"
            [attr.data-convite]="cartao.convite.id"
          >
            @if (cartao.etapa === 'aceito') {
              <div class="flex items-start gap-2.5">
                <app-icon name="circle_check" size="18" class="mt-0.5 shrink-0 text-success" />
                <p class="text-sm font-semibold text-content-primary">
                  Pronto, você agora tem acesso à {{ cartao.nomeEmpresaAceita }}.
                </p>
              </div>
              <div class="flex justify-end">
                <button
                  type="button"
                  appButton
                  size="sm"
                  [disabled]="trocando()"
                  (click)="trocarParaEmpresa(cartao.convite.id)"
                >
                  Trocar para a empresa
                </button>
              </div>
            } @else if (cartao.etapa === 'invalido') {
              <div class="flex flex-col gap-1">
                <p class="text-sm font-semibold text-content-primary">{{ cartao.convite.nomeEmpresa }}</p>
                <p data-teste="convite-invalido" class="text-sm text-content-secondary">Este convite não vale mais.</p>
              </div>
            } @else {
              <div class="flex flex-col gap-1">
                <p class="text-sm font-semibold text-content-primary">
                  Você foi convidado para a {{ cartao.convite.nomeEmpresa }}
                </p>
                <p class="text-xs text-content-tertiary">
                  Convite de {{ cartao.convite.nomeQuemConvidou }}. Vale até
                  {{ cartao.convite.expiraEm | date: 'dd/MM/yyyy' }}.
                </p>
              </div>

              @if (cartao.etapa === 'codigo') {
                <div class="flex flex-col gap-1.5">
                  <label appLabel [attr.for]="'codigo-' + cartao.convite.id">
                    Digite o código de 6 dígitos que enviamos para o seu e-mail
                  </label>
                  <input
                    appInput
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    placeholder="000000"
                    class="w-full tracking-[0.3em]"
                    [id]="'codigo-' + cartao.convite.id"
                    [attr.maxlength]="tamanhoCodigo"
                    [value]="cartao.codigo"
                    (input)="digitarCodigo(cartao.convite.id, $event)"
                    (keydown.enter)="confirmar(cartao.convite.id)"
                  />
                </div>
              }

              @if (cartao.erro) {
                <p class="text-sm text-red-500" role="alert">{{ cartao.erro }}</p>
              }

              <div class="flex flex-wrap items-center justify-end gap-2">
                @if (cartao.etapa === 'codigo') {
                  <button
                    type="button"
                    appButton
                    variant="link"
                    size="sm"
                    class="mr-auto text-color-brand"
                    [disabled]="cartao.enviando"
                    (click)="reenviarCodigo(cartao.convite.id)"
                  >
                    Reenviar código
                  </button>
                  <button
                    type="button"
                    appButton
                    size="sm"
                    [disabled]="!codigoCompleto(cartao) || cartao.enviando"
                    (click)="confirmar(cartao.convite.id)"
                  >
                    Confirmar
                  </button>
                } @else {
                  <button
                    type="button"
                    appButton
                    variant="secondary"
                    size="sm"
                    [disabled]="cartao.enviando"
                    (click)="pedirRecusa(cartao.convite.id)"
                  >
                    Recusar
                  </button>
                  <button
                    type="button"
                    appButton
                    size="sm"
                    [disabled]="cartao.enviando"
                    (click)="aceitar(cartao.convite.id)"
                  >
                    Aceitar
                  </button>
                }
              </div>
            }
          </article>
        }
      </div>
    </div>

    <app-modal-footer>
      <div class="flex w-full justify-end">
        <button type="button" appButton variant="secondary" size="xs" (click)="fechar()">Decidir depois</button>
      </div>
    </app-modal-footer>
  </app-modal>

  <!-- Depois da modal do aviso, para ficar por cima dela. -->
  <app-dialog-confirmacao
    [aberto]="recusaPendente() !== null"
    titulo="Recusar convite"
    [mensagem]="
      'O convite para a ' +
      (recusaPendente()?.nomeEmpresa ?? '') +
      ' deixa de valer. Quem convidou vai ver que você recusou.'
    "
    textoConfirmar="Recusar"
    textoCancelar="Voltar"
    [perigo]="true"
    (confirmar)="confirmarRecusa()"
    (cancelar)="desistirRecusa()"
  />
}
